// extracted by mini-css-extract-plugin
export var active = "_i0-7";
export var blink = "_i0-8";
export var dropDownSelector = "_i0-4";
export var dropDownWrapper = "_i0-3";
export var fakeCursor = "_i0-6";
export var fontSizeButton = "_i0-9";
export var formQuillEditor = "_i0-0";
export var pressed = "_i0-a";
export var qlBlank = "_i0-1";
export var textFormattingToolbar = "_i0-2";
export var textToolbarOption = "_i0-5";